import { dropHintFilesLabel, dropHintMessagesLabel } from './ComposeDropHint.locstring.json';
import { observer } from 'mobx-react';
import { logUsage } from 'owa-analytics';
import DropViewState from 'owa-dnd/lib/store/schema/DropViewState';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { DockingPluginBase } from 'owa-editor-docking-plugin';
import loc from 'owa-localize';
import * as React from 'react';

export interface ComposeDropHintProps {
    dataTransferType: string;
    dropViewState: DropViewState;
    dockingPlugin: DockingPluginBase;
}

const styles = require('./ComposeDropHint.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class ComposeDropHint extends React.Component<ComposeDropHintProps, {}> {
    componentDidMount() {
        this.logPrimaryViewDataTransferDatapoints();
    }

    componentDidUpdate() {
        this.logPrimaryViewDataTransferDatapoints();
    }

    render() {
        const { dataTransferType, dropViewState, dockingPlugin } = this.props;
        let label: string;
        switch (dataTransferType) {
            case DraggableItemTypes.MailListRow:
            case DraggableItemTypes.MultiMailListConversationRows:
            case DraggableItemTypes.MultiMailListMessageRows:
                label = loc(dropHintMessagesLabel);
                break;
            case DraggableItemTypes.LocalFile:
                label = loc(dropHintFilesLabel);
                break;
            case DraggableItemTypes.Attachment:
                label = loc(dropHintFilesLabel);
                break;
            default:
                return null;
        }

        const info = dockingPlugin.getVisibleAreaInfo();
        const pxString = 'px';
        const dropHintAreaCSS = {
            top: info.top + pxString,
            bottom: info.bottom + pxString,
        };

        const shouldDisplayInBigSize: boolean =
            info.visibleBodyHeight >= 200 && info.visibleBodyWidth >= 400;

        const dropHintAreaClassNames = classNames(styles.dropHintAreaInner, {
            isDraggingItemsIntoEditor: dropViewState.isDragOver,
            useSmallSizeDropHint: !shouldDisplayInBigSize,
        });

        return (
            <span className={styles.dropHintArea} style={dropHintAreaCSS}>
                <span className={dropHintAreaClassNames}>
                    <span className={styles.dropHintIcon} />
                    <span className={styles.dropHintLabel}>{label}</span>
                </span>
            </span>
        );
    }

    private logPrimaryViewDataTransferDatapoints() {
        logUsage('ComposeDropHint', [this.props.dataTransferType]);
    }
}
